/** Every distinct destination on file, trimmed and sorted, for pickers. */
export const uniqueDestinations = (invoices: Array<{ destination?: string }>): string[] =>
  Array.from(
    new Set(
      invoices
        .map(invoice => (invoice.destination || '').trim())
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b));

/** Case-insensitive partial match, so "san" finds "San Diego" and "Air Center San Diego". */
export const matchesDestination = (destination: string | undefined, term: string): boolean => {
  const needle = term.trim().toLowerCase();
  if (!needle) return true;
  return (destination || '').toLowerCase().includes(needle);
};
